import metrologo from '../images/metro-logo-footer-white-.png';
import AlertF from './AlertF.js';
import React, { useState } from 'react';

export default function Footer() {
    const [emailPopup, setEmailPopup] = useState({
        open: false,
        email: '',
        subject: '',
        title: ''
    });

    const openEmailPopup = (email, subject, title) => {
        setEmailPopup({ open: true, email, subject, title });
    };

    const closeEmailPopup = () => {
        setEmailPopup({ open: false, email: '', subject: '', title: '' });
    };

    const handleCopyEmail = async () => {
        try {
            await navigator.clipboard.writeText(emailPopup.email);
        } catch (err) {
            window.prompt('Copy email address:', emailPopup.email);
        }
    };

    const mailtoHref = emailPopup.email
        ? `mailto:${emailPopup.email}?subject=${encodeURIComponent(emailPopup.subject || '')}`
        : '#';

    return (
         <>  
            <div className='text-center text-lg-start Footer'>
                <section className='d-flex justify-content-center justify-content-lg-between p-4 border-bottom'></section>

                <section className=''>
                    <div className='container text-center text-md-start mt-5'>
                        <div className='row mt-3'>
                            <div className='col-md-3 col-lg-4 col-xl-3 mx-auto mb-4'>
                                <a href='/home' >
                                    <img src={metrologo} className='mLogo logoFooter' alt='mhb-site-logo.png' />
                                </a>
                            </div>

                            <div className='col-md-2 col-lg-2 col-xl-2 mx-auto mb-4'>
                                <h6 className='text-uppercase fw-bold mb-4'>IT Support</h6>
                                <p>
                                    <button
                                        type="button"
                                        className='btn btn-link text-reset p-0'
                                        onClick={() =>
                                            openEmailPopup(
                                                'portalhelp@metrohousingboston.org',
                                                '[Technical Support]',
                                                'Technical Support'
                                            )
                                        }
                                    >
                                        Technical Support
                                    </button>
                                </p>
                                <p>
                                    <button
                                        type="button"
                                        className='btn btn-link text-reset p-0'
                                        onClick={() =>
                                            openEmailPopup(
                                                'OwnerServices@metrohousingboston.org',
                                                '[Owner Services]',
                                                'Owner Services'
                                            )
                                        }
                                    >
                                        Owner Services
                                    </button>
                                </p>
                                <p>
                                    <button
                                        type="button"
                                        className='btn btn-link text-reset p-0'
                                        onClick={() =>
                                            openEmailPopup(
                                                'portalhelp@metrohousingboston.org',
                                                '[Report Duplicate Payments]',
                                                'Report Duplicate Payments'
                                            )
                                        }
                                    >
                                        Report Duplicate Payments
                                    </button>
                                </p>
                                <p>
                                    <a target='_blank' rel='noreferrer' href='https://airtable.com/shrzMcypjWPdZaeLL' className='text-reset'>
                                        Voucher Increase Support
                                    </a>
                                </p>
                            </div>

                            <div className='col-md-3 col-lg-2 col-xl-2 mx-auto mb-4'>
                                <h6 className='text-uppercase fw-bold mb-4'>Metro Links</h6>
                                <p>
                                    <a target='_blank' rel='noreferrer' href='https://metrohousingboston.zendesk.com/hc/en-us' className='text-reset'>
                                        Leased Housing Help Center
                                    </a>
                                </p>
                                <p>
                                    <a target='_blank' rel='noreferrer' href='https://applyhousinghelp.mass.gov/s/?language=en_US&LanguageCode=en_US' className='text-reset'>
                                        Upgrade your Raft Application
                                    </a>
                                </p>
                                <p>
                                    <a target='_blank' rel='noreferrer' href='https://www.metrohousingboston.org/wp-content/uploads/2019/08/Direct-Deposit-Form-update-8.12.19-fillable-1.pdf' className='text-reset'>
                                        Update Direct Deposit
                                    </a>
                                </p>
                                <p>
                                    <a target='_blank' rel='noreferrer' href='https://forms.office.com/Pages/ResponsePage.aspx?id=J8xXIgxdK0y6AnOQOwjqAHVPPCEmmcRLu9IABP8zZRBUQlFDU0RFQUxRRjdCTzY4NTZQWjVMS09SVC4u' className='text-reset'>
                                        Submit Feedback
                                    </a>
                                </p>
                            </div>

                            <div className='col-md-4 col-lg-3 col-xl-3 mx-auto mb-md-0 mb-4'>
                                <h6 className='text-uppercase fw-bold mb-4'>Contact Us</h6>
                                <p>
                                    <i className='fas fa-home me-3'></i>
                                    1411 Tremont Street
                                    Boston, MA 02120-3401
                                </p>
                                <p>
                                    <i className='fas fa-envelope me-3'></i>
                                    E-mail: portalhelp@metrohousingboston.org
                                </p>
                                <p><i className='fas fa-phone me-3'></i> Phone: 617.859.0400</p>
                                <p><i className='fas fa-print me-3'></i> Toll-Free: 800.272.0990</p>
                            </div>
                        </div>
                    </div>
                </section>

                <div className='text-center p-4'>
                    © 2026 Copyright:
                  <a className='text-reset ' href='https://www.metrohousingboston.org/'>Metro Housing Boston</a>
                </div>
            </div>

            {emailPopup.open && (
                <div
                    className="modal d-block"
                    tabIndex="-1"
                    role="dialog"
                    style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}
                >
                    <div className="modal-dialog" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">{emailPopup.title}</h5>
                                <button
                                    type="button"
                                    className="btn-close"
                                    aria-label="Close"
                                    onClick={closeEmailPopup}
                                />
                            </div>
                            <div className="modal-body">
                                <p>Email: <strong>{emailPopup.email}</strong></p>
                                <button
                                    type="button"
                                    className="btn btn-outline-secondary me-2"
                                    onClick={handleCopyEmail}
                                >
                                    Copy Email
                                </button>
                                <a className="btn btn-primary" href={mailtoHref}>
                                    Send Email
                                </a>
                            </div>
                            <div className="modal-footer">
                                <button
                                    type="button"
                                    className="btn btn-secondary"
                                    onClick={closeEmailPopup}
                                >
                                    Close
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            <div className='Banner'>
                <AlertF/>
            </div>
        </> 
    )
};